<template>
  <b-col :xs="crossDisable ? 12 : 12" :sm="crossDisable ? 12 : 12" :md="crossDisable ? 6 : 6"
    :lg="crossDisable ? 4 : 4" :xl="crossDisable ? 4 : 4" class="mb-2 mb-lg-3">
    <b-card no-header no-body class="shadow-none border-radius-10 category-titles" :id="`${shortHand}_card`">
      <div class="category-titles-card d-block" v-on:click="onTitleClick()">
        <div class="category-titles-card-header">
          <b-card-title>{{ title }}</b-card-title>
        </div>
        <!-- <b-button id="show-btn" @click="showModal" class="cross-btn"><i class="fas fa-minus"></i></b-button> -->

        <!-- <div class="category-titles-card-body clr-box-btns d-flex align-items-center justify-space-between">
          <span class="clr-bx-btn category-titles-amount fixed-amount-value" v-if="!!fixAmount">
            {{ value | currency("$", 0) }}
          </span>
          <span class="clr-bx-btn category-titles-amount your-amount-value" v-else>
            <template v-if="value >= 0">
              {{ value | currency("$", 0) }}
            </template>
            <template v-else>
              $0
            </template>
          </span>
          <span class="clr-bx-btn category-titles-amount peers-amount-value" v-if="showPeer">
            {{ value1 | currency("$", 0) }}
          </span>
        </div> -->
        <div class="category-titles-card-body clr-box-btns d-flex align-items-center">
          <span v-if="!!fixAmount" class="clr-bx-btn fixed-amount text-center py-1 px-1" style="width: 100%"
            v-b-tooltip.hover="{ variant: 'primary' }" title="Your Amount"
            :style="{ width: `${percantageCal(value)}%` }">
            {{ value | currency("$", 0) }}
          </span>
          <span v-else class="clr-bx-btn your-amount text-center py-1 px-1" :class="{ 'negative-bg': getColor(value) }"
            style="" v-b-tooltip.hover="{ variant: 'primary' }" title="Predicted Amount"
            :style="{ width: `${percantageCal(value)}%` }">
            <template v-if="value > 0">
              {{ value | currency("$", 0) }}
            </template>
            <template v-else>
              {{value1 | currency("$", 0)}}
            </template>
          </span>
          <span v-if="showPeer" class="clr-bx-btn peers-amount text-center py-1 px-1"
            :class="{ 'negative-bg': getColor(value1) }" style="width: 60%" v-b-tooltip.hover="{ variant: 'primary' }"
            title="Your Peers" :style="{ width: `${percantageCal(value1)}%` }">
            {{ value1 | currency("$", 0) }}
          </span>
        </div>
        <div class="edit-budget-amount">
          <div class="d-flex justify-content-between">
            <a role="button" class="mx-2 font-weight-bold your-amount-text">
              <i class="fas fa-pencil-alt mr-1"></i>
              Your Amount
            </a>
            <span class="mx-2 font-weight-bold your-peers-text">
              Your Peers
            </span>
          </div>
        </div>
      </div>
      <div :id="`${shortHand}_card_click`" class="add-fudget-form mt-2 border rounded p-2 bg-light" ref="ddd-n"
        :class="{ 'd-none': isHidden || defaultActive != title }">
        <div class="position-relative d-block">
          <b-form class="m-1" @submit="onSubmit">
            <b-row class="mb-3">
              <b-col cols="6">
                <template v-if="checkIcon">
                  <b-button size="sm" @click="changeUsesvalue(title)" class="get_advice_btn">
                    Ideas
                  </b-button>
                </template>
              </b-col>
              <b-col cols="6" class="text-right">
                <b-button class="about-you-accordion clear-amount-btn" size="sm" variant="danger" @click="
                  fixAmount = null;
                fixAmt();
                ">Reset</b-button>
              </b-col>
            </b-row>
            <b-form-group label="Fixed Amount" class="custom-form-control">
              <NumberInput :model="fixAmount" @changeValue="numberValueChange" name="fixAmount"
                class="big-input-font" />
            </b-form-group>
            <b-form-group label="Frequency" class="custom-form-control">
              <b-form-select v-model="frequency" :options="[
                { text: 'Monthly', value: 12 },
                { text: 'Weekly', value: 52 },
                { text: 'Quarterly', value: 4 },
                { text: 'Semi-Annually', value: 2 },
                { text: 'Annually', value: 1 },
              ]" :value="null" class="big-input-font">
              </b-form-select>
            </b-form-group>
          </b-form>
          <b-form-group class="text-center">
            <b-button type="button" class="btn-green" size="sm" @click="closeClick()">
              <!-- Update Edit Amount -->
              Close
            </b-button>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <b-modal id="chatGptList" v-model="modalShow" scrollable size="xl" content-class="get-advice-modal"
      v-if="modalShow == true" hide-footer>
      <ChatGptList :uses="uses" />
    </b-modal>

    <b-modal ref="modalremoveCatgory" hide-header hide-footer>
      <div class="mb-4 d-block text-center">
        <i class="fas fa-exclamation-circle text-warning fa-5x"></i>
      </div>
      <div class="my-4 d-block text-center">
        <h3 class="font-weight-bold">Are you sure?</h3>
        <p>You want to <b>Remove</b> this category?</p>
      </div>
      <div class="my-4 d-block text-center">
        <b-button @click="hideModal" variant="danger" class="mx-1">
          Cancel
        </b-button>
        <b-button v-if="!crossDisable" @click="$emit('event', title)" type="button"
          class="mx-1 btn-green">Remove</b-button>
      </div>
    </b-modal>
  </b-col>
</template>

<script>
import NumberInput from "@/components/NumberInput";
import ChatGptList from "@/components/ChatGptList";
import transformer_38 from "@/transformers/transformer_new";
import transformer_links from "@/transformers/transformer_links";
export default {
  name: "budget-component",
  props: {
    title: String,
    value1: Number,
    value2: Number,
    frequencyOptions: Array,
    showPeer: Boolean,
    grid: Boolean,
    defaultValues: Object,
    zip: String,
    age: {
      type: [String, Number],
    },
    crossDisable: {
      type: Boolean,
      default: () => false,
    },
    defaultActiveTab: String,
    householdMembers: {
      type: [String, Number],
    }
  },
  data() {
    return {
      modalShow: false,
      modalremoveCatgory: false,
      uses: "",
      value: "",
      //   showInside: false,
      isHidden: true,
      fixAmount: null,
      frequency: 12,
      defaultActive: "",
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  components: {
    NumberInput,
    ChatGptList,
  },
  watch: {
    defaultActiveTab: {
      handler(data) {
        this.defaultActive = data;
      },
      deep: true,
    },
    defaultValues: {
      handler(data) {
        this.value = this.value2;
        const short_hand = Object.keys(transformer_38).find(
          (item) => transformer_38[item] === this.title
        );
        if (data[short_hand]) {
          this.value =
            data[short_hand].value && parseInt(data[short_hand].value);
          this.fixAmount = `${data[short_hand].value}`;
          this.frequency = data[short_hand].freq;
        }
        // else {
        //     const matched = Object.keys(this.defaultValues).find(item => item.includes(short_hand));
        //     if(matched){
        //         this.value = this.defaultValues[matched].value && parseInt(this.defaultValues[matched].value);
        //         this.fixAmount = `$${this.defaultValues[matched].value}`;
        //         this.frequency = this.defaultValues[matched].freq;
        //     }
        // }
      },
      deep: true,
    },
    value2: {
      handler() {
        this.value = this.value2;
      },
      deep: true,
    },
    fixAmount() {
      // this.$emit('changeValue', this.title,parseInt(this.unmaskMoneyValue(this.fixAmount))*this.frequency || null,this.unmaskMoneyValue(this.fixAmount),this.frequency)
    },
    frequency() {
      this.$emit(
        "changeValue",
        this.title,
        parseInt(this.fixAmount) * this.frequency || null,
        this.fixAmount,
        this.frequency
      );
    },
  },
  mounted() {
    this.value = this.value2;
    const short_hand = Object.keys(transformer_38).find(
      (item) => transformer_38[item] === this.title
    );
    if (this.defaultValues[short_hand]) {
      this.value =
        this.defaultValues[short_hand].value &&
        parseInt(this.defaultValues[short_hand].value);
      this.fixAmount = `$${this.defaultValues[short_hand].value}`;
      this.frequency = this.defaultValues[short_hand].freq;
    } else {
      const matched = Object.keys(this.defaultValues).find((item) =>
        item.includes(short_hand)
      );
      if (matched) {
        this.value =
          this.defaultValues[matched].value &&
          parseInt(this.defaultValues[matched].value);
        this.fixAmount = `$${this.defaultValues[matched].value}`;
        this.frequency = this.defaultValues[matched].freq;
      }
    }
  },
  methods: {
    closeClick() {
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    onTitleClick() {
      this.isHidden = false;
      this.$emit("defaultActiveTabAction", this.title);
    },
    changeUsesvalue(title) {
      // alert(title)
      const data = {
        title,
        predicted: this.value2,
        peer: this.value1,
        type: "Other",
        zip: this.zip,
        age: this.age,
        size: this.householdMembers,
      };
      this.uses = data;
      this.modalShow = true;
    },
    onSubmit(event) {
      event.preventDefault();
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
      this.fixAmt();
    },
    hideMenus() {
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    hideModal() {
      this.$refs["modalremoveCatgory"].hide();
    },
    showModal() {
      this.$refs["modalremoveCatgory"].show();
    },
    // hidePopup() {
    //   this.showInside = false;
    //   this.$refs["ddd-n"].classList.add("d-none");
    //    var element = document.getElementById(`${this.shortHand}_card_click`);
    //    element.classList.add("d-none");
    // },
    fixAmt() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
    percantageCal(arg) {
      //   if(!!this.fixAmount){
      //     const fixAmount = parseInt(this.unmaskMoneyValue(this.fixAmount))
      //     const total = this.value1+fixAmount

      //     if(typeof arg === 'string')
      //         return (fixAmount/total)*100
      //     else
      //         return (arg/total)*100
      //   } else {
      const total = this.value1 + this.value;
      if (total === 0 && this.grid === true) return 50;
      else if (total === 0 && this.grid === false) return 4;
      else return (arg / total) * 100;
      //   }
    },
    getColor(arg) {
      if (arg < 0) {
        return true;
      } else {
        return false;
      }
    },
    unmaskMoneyValue(val) {
      if (val && typeof val === "string")
        return val.replace("$", "").replace(",", "");
      else return val;
    },
    show: function () {
      this.showInside = true;
    },
    hide: function () {
      this.showInside = false;
    },
  },
  computed: {
    // a computed getter
    checkIcon() {
      const short_hand = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
      return transformer_links[short_hand];
    },
    shortHand() {
      return Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
    },
  },
};
</script>
